<template>
  <div
    v-bind="$attrs"
    v-on="$listeners"
    :style="style.root"
  >
    <div :style="style.container">
      <template
        v-for="(step, index) in steps"
      >
        <div
          :key="index"
          :style="style.nodeContainer"
        >
          <div
            :disabled="disabled"
            :doing="isDoing(index)"
            :done="isDone(index)"
            :waiting="isWaiting(index)"
            :class="$style.node"
            :style="style.node"
          >
            <slot
              name="node"
              :step="step"
              :index="index"
            />
          </div>
          <div
            :disabled="disabled"
            :doing="isDoing(index)"
            :done="isDone(index)"
            :waiting="isWaiting(index)"
            :class="$style.label"
            :style="style.label"
          >
            <slot
              name="label"
              :step="step"
              :index="index"
            />
          </div>
        </div>
        <div
          v-if="index < steps.length - 1"
          :key="`${index}_link`"
          :style="style.linkContainer"
        >
          <div
            :disabled="disabled"
            :doing="isDoing(index)"
            :done="isDone(index)"
            :waiting="isWaiting(index)"
            :class="$style.link"
            :style="style.link"
          >
            <slot
              name="link"
              :step="step"
              :index="index"
            />
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
  import { CssStyleProcessor } from '@js/vue-style-utils'

  export default {
    name: 'BaseStepIndicator',
    inheritAttrs: false,
    props: {
      disabled: {
         type: Boolean,
        required: false,
        default: false,
      },
      stepIndex: {
        type: Number,
        required: false,
        default: 0,
      },
      steps: {
        type: Array,
        required: false,
        default: () => [],
      },
      styleConfig: {
        type: Object,
        required: false,
        default: () => {},
      },
    },
    data: function () {
      return {
        style: {
          container: {
            alignItems: 'center',
            display: 'flex',
            justifyContent: 'space-between',
            width: '100%',
          },
          label: {
            bottom: 0,
            left: '50%',
            position: 'absolute',
            textAlign: 'center',
            transform: 'translate(-50%, 100%)',
          },
          link: {
          },
          linkContainer: {},
          node: {},
          nodeContainer: {
            alignItems: 'flex-start',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            position: 'relative',
          },
          root: {},
        },
      };
    },
    created: function () {
      const proc = new CssStyleProcessor(
        '--v2-base-step-indicator',
        ['doing', 'done', 'waiting'],
      );

      Object.assign(
        this.style.label,
        proc.getExtendedStyle(this.styleConfig.label, 'label'),
      );
      Object.assign(
        this.style.link,
        proc.getExtendedStyle(this.styleConfig.link, 'link'),
      );
      Object.assign(
        this.style.node,
        proc.getExtendedStyle(this.styleConfig.node, 'node'),
      );

      Object.assign(
        this.style.container,
        this.styleConfig.container,
      );
      Object.assign(
        this.style.linkContainer,
        this.styleConfig.linkContainer,
      );
      Object.assign(
        this.style.nodeContainer,
        this.styleConfig.nodeContainer,
      );
      Object.assign(
        this.style.root,
        this.styleConfig.root,
      );
    },
    methods: {
      isDoing: function (index) {
        return index === this.stepIndex;
      },
      isDone: function (index) {
        return index < this.stepIndex;
      },
      isWaiting: function (index) {
        return index > this.stepIndex;
      },
    },
  };
</script>

<style lang="stylus" module>
  .node
    background-color var(--v2-base-step-indicator-node-background-color)
    border var(--v2-base-step-indicator-node-border)
    border-radius var(--v2-base-step-indicator-node-border-radius)
    border-width var(--v2-base-step-indicator-node-border-width)
    box-shadow var(--v2-base-step-indicator-node-box-shadow)
    color var(--v2-base-step-indicator-node-color)
    font-family var(--v2-base-step-indicator-node-font-family)
    font-size var(--v2-base-step-indicator-node-font-size)
    font-weight var(--v2-base-step-indicator-node-font-weight)
    &[doing]
      background-color var(--v2-base-step-indicator-node-background-color-doing)
      border var(--v2-base-step-indicator-node-border-doing)
      border-radius var(--v2-base-step-indicator-node-border-radius-doing)
      border-width var(--v2-base-step-indicator-node-border-width-doing)
      box-shadow var(--v2-base-step-indicator-node-box-shadow-doing)
      color var(--v2-base-step-indicator-node-color-doing)
      font-family var(--v2-base-step-indicator-node-font-family-doing)
      font-size var(--v2-base-step-indicator-node-font-size-doing)
      font-weight var(--v2-base-step-indicator-node-font-weight-doing)
    &[done]
      background-color var(--v2-base-step-indicator-node-background-color-done)
      border var(--v2-base-step-indicator-node-border-done)
      border-radius var(--v2-base-step-indicator-node-border-radius-done)
      border-width var(--v2-base-step-indicator-node-border-width-done)
      box-shadow var(--v2-base-step-indicator-node-box-shadow-done)
      color var(--v2-base-step-indicator-node-color-done)
      font-family var(--v2-base-step-indicator-node-font-family-done)
      font-size var(--v2-base-step-indicator-node-font-size-done)
      font-weight var(--v2-base-step-indicator-node-font-weight-done)
    &[waiting]
      background-color var(--v2-base-step-indicator-node-background-color-waiting)
      border var(--v2-base-step-indicator-node-border-waiting)
      border-radius var(--v2-base-step-indicator-node-border-radius-waiting)
      border-width var(--v2-base-step-indicator-node-border-width-waiting)
      box-shadow var(--v2-base-step-indicator-node-box-shadow-waiting)
      color var(--v2-base-step-indicator-node-color-waiting)
      font-family var(--v2-base-step-indicator-node-font-family-waiting)
      font-size var(--v2-base-step-indicator-node-font-size-waiting)
      font-weight var(--v2-base-step-indicator-node-font-weight-waiting)
    &[disabled]
      background-color var(--v2-base-step-indicator-node-background-color-disabled)
      border var(--v2-base-step-indicator-node-border-disabled)
      border-radius var(--v2-base-step-indicator-node-border-radius-disabled)
      border-width var(--v2-base-step-indicator-node-border-width-disabled)
      box-shadow var(--v2-base-step-indicator-node-box-shadow-disabled)
      color var(--v2-base-step-indicator-node-color-disabled)
      font-family var(--v2-base-step-indicator-node-font-family-disabled)
      font-size var(--v2-base-step-indicator-node-font-size-disabled)
      font-weight var(--v2-base-step-indicator-node-font-weight-disabled)

  .link
    background-color var(--v2-base-step-indicator-link-background-color)
    border var(--v2-base-step-indicator-link-border)
    border-radius var(--v2-base-step-indicator-link-border-radius)
    border-width var(--v2-base-step-indicator-link-border-width)
    box-shadow var(--v2-base-step-indicator-link-box-shadow)
    &[doing]
      background-color var(--v2-base-step-indicator-link-background-color-doing)
      border var(--v2-base-step-indicator-link-border-doing)
      border-radius var(--v2-base-step-indicator-link-border-radius-doing)
      border-width var(--v2-base-step-indicator-link-border-width-doing)
      box-shadow var(--v2-base-step-indicator-link-box-shadow-doing)
    &[done]
      background-color var(--v2-base-step-indicator-link-background-color-done)
      border var(--v2-base-step-indicator-link-border-done)
      border-radius var(--v2-base-step-indicator-link-border-radius-done)
      border-width var(--v2-base-step-indicator-link-border-width-done)
      box-shadow var(--v2-base-step-indicator-link-box-shadow-done)
    &[waiting]
      background-color var(--v2-base-step-indicator-link-background-color-waiting)
      border var(--v2-base-step-indicator-link-border-waiting)
      border-radius var(--v2-base-step-indicator-link-border-radius-waiting)
      border-width var(--v2-base-step-indicator-link-border-width-waiting)
      box-shadow var(--v2-base-step-indicator-link-box-shadow-waiting)
    &[disabled]
      background-color var(--v2-base-step-indicator-link-background-color-disabled)
      border var(--v2-base-step-indicator-link-border-disabled)
      border-radius var(--v2-base-step-indicator-link-border-radius-disabled)
      border-width var(--v2-base-step-indicator-link-border-width-disabled)
      box-shadow var(--v2-base-step-indicator-link-box-shadow-disabled)

  .label
    background-color var(--v2-base-step-indicator-label-background-color)
    border var(--v2-base-step-indicator-label-border)
    border-radius var(--v2-base-step-indicator-label-border-radius)
    border-width var(--v2-base-step-indicator-label-border-width)
    box-shadow var(--v2-base-step-indicator-label-box-shadow)
    color var(--v2-base-step-indicator-label-color)
    font-family var(--v2-base-step-indicator-label-font-family)
    font-size var(--v2-base-step-indicator-label-font-size)
    font-weight var(--v2-base-step-indicator-label-font-weight)
    &[doing]
      background-color var(--v2-base-step-indicator-label-background-color-doing)
      border var(--v2-base-step-indicator-label-border-doing)
      border-radius var(--v2-base-step-indicator-label-border-radius-doing)
      border-width var(--v2-base-step-indicator-label-border-width-doing)
      box-shadow var(--v2-base-step-indicator-label-box-shadow-doing)
      color var(--v2-base-step-indicator-label-color-doing)
      font-family var(--v2-base-step-indicator-label-font-family-doing)
      font-size var(--v2-base-step-indicator-label-font-size-doing)
      font-weight var(--v2-base-step-indicator-label-font-weight-doing)
    &[done]
      background-color var(--v2-base-step-indicator-label-background-color-done)
      border var(--v2-base-step-indicator-label-border-done)
      border-radius var(--v2-base-step-indicator-label-border-radius-done)
      border-width var(--v2-base-step-indicator-label-border-width-done)
      box-shadow var(--v2-base-step-indicator-label-box-shadow-done)
      color var(--v2-base-step-indicator-label-color-done)
      font-family var(--v2-base-step-indicator-label-font-family-done)
      font-size var(--v2-base-step-indicator-label-font-size-done)
      font-weight var(--v2-base-step-indicator-label-font-weight-done)
    &[waiting]
      background-color var(--v2-base-step-indicator-label-background-color-waiting)
      border var(--v2-base-step-indicator-label-border-waiting)
      border-radius var(--v2-base-step-indicator-label-border-radius-waiting)
      border-width var(--v2-base-step-indicator-label-border-width-waiting)
      box-shadow var(--v2-base-step-indicator-label-box-shadow-waiting)
      color var(--v2-base-step-indicator-label-color-waiting)
      font-family var(--v2-base-step-indicator-label-font-family-waiting)
      font-size var(--v2-base-step-indicator-label-font-size-waiting)
      font-weight var(--v2-base-step-indicator-label-font-weight-waiting)
    &[disabled]
      background-color var(--v2-base-step-indicator-label-background-color-disabled)
      border var(--v2-base-step-indicator-label-border-disabled)
      border-radius var(--v2-base-step-indicator-label-border-radius-disabled)
      border-width var(--v2-base-step-indicator-label-border-width-disabled)
      box-shadow var(--v2-base-step-indicator-label-box-shadow-disabled)
      color var(--v2-base-step-indicator-label-color-disabled)
      font-family var(--v2-base-step-indicator-label-font-family-disabled)
      font-size var(--v2-base-step-indicator-label-font-size-disabled)
      font-weight var(--v2-base-step-indicator-label-font-weight-disabled)
</style>
